import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectOrganization } from '../../../Actions/Login.action';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import { translate } from '../../../Services/translation';
import Dropdown from '../../Dropdown';
import clsx from 'clsx';

const LoginSelectOrganization = () => {
  const dispatch = useDispatch();
  const { organizations, isLoading } = useTypedSelector(
    (state) => state.login
  );
  const [selectedOrganizationId, setSelectedOrganizationId] = useState<
    string | undefined
  >();

  return organizations ? (
    <>
      <h1 className={clsx('mb-6')}>
        {translate('login.choose-organization')}
      </h1>
      <Dropdown
        placeholder={translate('login.choose-organization')}
        onChange={({ value }) => setSelectedOrganizationId(value)}
        options={organizations.map((org) => ({
          value: org.systemId,
          label: org.name,
        }))}
        selectedValue={selectedOrganizationId}
        disabled={isLoading}
      />
      <button
        className={clsx(
          'button',
          'btn',
          'btn--primary',
          'btn--large',
          'w-full',
          'mt-8'
        )}
        onClick={() =>
          selectedOrganizationId &&
          dispatch(selectOrganization(selectedOrganizationId))
        }
        disabled={isLoading || !selectedOrganizationId}
      >
        {!isLoading && translate('general.select')}
        {isLoading && translate('general.loading')}
      </button>
    </>
  ) : null;
};

export default LoginSelectOrganization;
